import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  GLOBAL_STATE,
  HR_APPLICATION,
  HR_APPLICATION_ALL,
  HR_APPLICATION_FIELD_BATCH,
  HR_APPLICATION_LIST,
  HR_APPLICATION_REQUEST,
  HR_APPLICATION_REQUEST_ALL,
  HR_APPLICATION_REQUEST_EDIT,
  HR_APPLICATION_REQUEST_UPDATE,
  HR_APPLICATION_STATUS,
  HR_APPLICATION_TYPES,
} from '../constants/actionTypes'

const hrAdmissionSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const hrApplicationSelector = createSelector(hrAdmissionSelector, data => data[HR_APPLICATION])

export const hrApplicationListSelector = createSelector(hrAdmissionSelector, data => data[HR_APPLICATION_LIST])

export const hrApplicationTypesSelector = createSelector(hrAdmissionSelector, data => data[HR_APPLICATION_TYPES])

export const hrApplicationStatusSelector = createSelector(hrAdmissionSelector, data => data[HR_APPLICATION_STATUS])

export const hrApplicationAllSelector = createSelector(hrAdmissionSelector, data => data[HR_APPLICATION_ALL])

export const hrApplicationFieldBatchSelector = createSelector(
  hrAdmissionSelector,
  data => data[HR_APPLICATION_FIELD_BATCH]
)

// request
export const hrApplicationRequestSelector = createSelector(hrAdmissionSelector, data => data[HR_APPLICATION_REQUEST])

export const hrApplicationRequestAllSelector = createSelector(
  hrAdmissionSelector,
  data => data[HR_APPLICATION_REQUEST_ALL]
)
export const hrApplicationRequestEditSelector = createSelector(
  hrAdmissionSelector,
  data => data[HR_APPLICATION_REQUEST_EDIT]
)

export const hrApplicationRequestUpdateSelector = createSelector(
  hrAdmissionSelector,
  data => data[HR_APPLICATION_REQUEST_UPDATE]
)

// category
// export const hrApplicationCategorySelector = createSelector(
// hrAdmissionSelector,
//   data => data[]
// )
// export const hrApplicationCategoryListSelector = createSelector(
// hrAdmissionSelector,
//   data => data[]
// )
// export const hrApplicationCategoryAllSelector = createSelector(
// hrAdmissionSelector,
//   data => data[]
// )
